import { action } from 'typesafe-actions';
import {
  IPriceAlert,
  IPriceAlertCreatePayload,
  IPriceAlertUpdatePayload,
  IPriceAlertsResponse,
  ITicker,
} from '@kattana-io/common';

const entity = 'price_alerts';

const ACTION_ADD_PRICE_ALERT = `${entity}/ADD_ALERT`;
const ACTION_DUPLICATE_PRICE_ALERT = `${entity}/DUPLICATE_PRICE_ALERT`;
const ACTION_CREATE_PRICE_ALERT = `${entity}/CREATE_PRICE_ALERT`;
const ACTION_CONSUME_ALERT = `${entity}/CONSUME_ALERT`;
const ACTION_CANCEL_ALERT = `${entity}/CANCEL_ALERT`;
const ACTION_GET_PRICE_ALERTS = `${entity}/GET_PRICE_ALERTS`;
const ACTION_SET_PRICE_ALERTS = `${entity}/SET_PRICE_ALERTS`;
const ACTION_SET_PRICE_ALERTS_TICKERS = `${entity}/SET_PRICE_ALERTS_TICKERS`;
const ACTION_TRIGGER_PRICE_ALERT = `${entity}/TRIGGER_PRICE_ALERT`;
const ACTION_UPDATE_PRICE_ALERT_PRICE = `${entity}/UPDATE_PRICE_ALERT_PRICE`;
const ACTION_PUT_PRICE_ALERT = `${entity}/PUT_PRICE_ALERT`;
const ACTION_SET_CREATING_PRICE_ALERTS = `${entity}/SET_CREATING_FLAG`;

const actionGetPriceAlerts = (wallet: string) =>
  action(ACTION_GET_PRICE_ALERTS, wallet);
const actionSetPriceAlerts = (payload: IPriceAlertsResponse) =>
  action(ACTION_SET_PRICE_ALERTS, payload);
const actionSetPriceAlertsTickers = (payload: Record<string, ITicker>) =>
  action(ACTION_SET_PRICE_ALERTS_TICKERS, payload);
const actionAddPriceAlert = (payload: IPriceAlert) =>
  action(ACTION_ADD_PRICE_ALERT, payload);
const actionDuplicatePriceAlert = (payload: IPriceAlert) =>
  action(ACTION_DUPLICATE_PRICE_ALERT, payload);
const actionCreatePriceAlert = (payload: IPriceAlertCreatePayload) =>
  action(ACTION_CREATE_PRICE_ALERT, payload);
const actionConsumePriceAlert = (payload: IPriceAlertUpdatePayload) =>
  action(ACTION_CONSUME_ALERT, payload);
const actionCancelPriceAlert = (payload: IPriceAlertUpdatePayload) =>
  action(ACTION_CANCEL_ALERT, payload);
const actionTriggerPriceAlert = (payload: IPriceAlert) =>
  action(ACTION_TRIGGER_PRICE_ALERT, payload);
const actionUpdateAlertPrice = (payload: IPriceAlert) =>
  action(ACTION_UPDATE_PRICE_ALERT_PRICE, payload);
const actionPutPriceAlert = (payload: IPriceAlert) =>
  action(ACTION_PUT_PRICE_ALERT, payload);
const actionSetCreatingPriceAlerts = (payload: boolean) =>
  action(ACTION_SET_CREATING_PRICE_ALERTS, payload);

export {
  ACTION_ADD_PRICE_ALERT,
  ACTION_CONSUME_ALERT,
  ACTION_GET_PRICE_ALERTS,
  ACTION_SET_PRICE_ALERTS,
  ACTION_SET_PRICE_ALERTS_TICKERS,
  ACTION_CREATE_PRICE_ALERT,
  ACTION_TRIGGER_PRICE_ALERT,
  ACTION_CANCEL_ALERT,
  ACTION_DUPLICATE_PRICE_ALERT,
  ACTION_UPDATE_PRICE_ALERT_PRICE,
  ACTION_PUT_PRICE_ALERT,
  ACTION_SET_CREATING_PRICE_ALERTS,
  actionAddPriceAlert,
  actionGetPriceAlerts,
  actionSetPriceAlerts,
  actionSetPriceAlertsTickers,
  actionConsumePriceAlert,
  actionCreatePriceAlert,
  actionTriggerPriceAlert,
  actionCancelPriceAlert,
  actionDuplicatePriceAlert,
  actionUpdateAlertPrice,
  actionPutPriceAlert,
  actionSetCreatingPriceAlerts,
};
